<template>
  <section class="modalContainer">
    <Meeting v-if="meeting" />
    <Drawer />
    <Attendee v-if="attendee" />
    <Timezone v-if="timezone" />
    <WizardNotifications v-if="notifications"/>
    <Repeating v-if="repeating" />
    <DeleteEventConfirmation v-if="deleteEventConfirmation" />
    <DeleteAttendeeConfirmation v-if="deleteAttendeeConfirmation" />
    <DeleteRecordingConfirmation v-if="deleteRecordingConfirmation" />
    <UpdateAttendeeConfirmation v-if="updateAttendeeConfirmation" />
    <FirstTimeWizard v-if="firstTimeWizard" />
    <SaveEventConfirmation v-if="saveEventConfirmation" />
    <DeleteEventSimpleConfirmation v-if="deleteEventSimpleConfirmation" />
    <AddGroup v-if="addGroup" />
    <updateProfileComp v-if="updateProfile" />
    <Auth2fa v-if="auth2faComputed" />
    <Web3WalletModal v-if="web3Modal" />
    <UpgradeRequired v-if="upgradeRequired" />
    <CounterProposeModal v-if="counterProposeModal.open && counterProposeModal.request" :request="counterProposeModal.request" />
    <DeleteAccountConfirmation v-if="deleteAccountConfirmation" />
    <Notifications />
  </section>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import Meeting from "@/components/Modals/NewMeeting";
import Attendee from "@/components/Modals/AddAttendee";
import AddGroup from "@/components/Modals/AddGroup";
import Timezone from "@/components/Modals/Timezone";
import Repeating from "@/components/Modals/Repeating";
import WizardNotifications from "@/components/Modals/WizardNotifications";
import Drawer from "@/components/Toolbars/Drawer";
import DeleteEventConfirmation from "@/components/Modals/DeleteEventConfirmation";
import DeleteAttendeeConfirmation from "@/components/Modals/DeleteAttendeeConfirmation";
import DeleteRecordingConfirmation from "@/components/Modals/DeleteRecordingConfirmation";
import FirstTimeWizard from "@/components/Modals/FirstTimeWizard";
import UpdateAttendeeConfirmation from "@/components/Modals/UpdateAttendeeConfirmation";
import Notifications from "@/components/Modals/Notifications";
import SaveEventConfirmation from "@/components/Modals/SaveEventConfirmation";
import DeleteEventSimpleConfirmation from "@/components/Modals/DeleteEventSimpleConfirmation";
import updateProfileComp from "@/components/Modals/updateProfile.vue";
import Auth2fa from "@/components/Modals/Auth2faModal.vue";
import Web3WalletModal from "@/components/Modals/Web3WalletModal.vue";
import UpgradeRequired from "@/components/Modals/UpgradeRequired.vue";
import CounterProposeModal from "@/components/Booking/CounterProposeModal.vue";
import DeleteAccountConfirmation from "@/components/Modals/DeleteAccountConfirmation.vue";

const store = useStore();
const updateProfile = computed(() => store.state.modals.updateProfile);
const meeting = computed(() => store.state.modals.meeting);
const attendee = computed(() => store.state.modals.attendee);
const addGroup = computed(() => store.state.modals.addGroup);
const notifications = computed(() => store.state.modals.notifications);
const timezone = computed(() => store.state.modals.timezone);
const repeating = computed(() => store.state.modals.repeating);
const deleteEventConfirmation = computed(() => store.state.modals.deleteEventConfirmation);
const deleteAttendeeConfirmation = computed(() => store.state.modals.deleteAttendeeConfirmation);
const deleteRecordingConfirmation = computed(() => store.state.modals.deleteRecordingConfirmation);
const firstTimeWizard = computed(() => store.state.modals.firstTimeWizard);
const updateAttendeeConfirmation = computed(() => store.state.modals.updateAttendeeConfirmation);
const saveEventConfirmation = computed(() => store.state.modals.saveEventConfirmation);
const deleteEventSimpleConfirmation = computed(() => store.state.modals.deleteEventSimpleConfirmation);
const auth2faComputed = computed(() => store.state.modals.auth2fa);
const web3Modal = computed(() => store.state.modals.web3Modal);
const upgradeRequired = computed(() => store.state.modals.upgradeRequired);
const counterProposeModal = computed(() => store.state.modals.counterProposeModal);
const deleteAccountConfirmation = computed(() => store.state.modals.deleteAccountConfirmation);
</script>